"use client";
import { jsx as C, Fragment as e } from "react/jsx-runtime";
import { createSvgIcon as r } from "@mui/material/utils";
const o = r(
  /* @__PURE__ */ C(e, { children: /* @__PURE__ */ C(
    "path",
    {
      d: "M11.9991 2.29004C6.64906 2.29004 2.28906 6.65004 2.28906 12C2.28906 17.35 6.64906 21.71 11.9991 21.71C17.3491 21.71 21.7091 17.35 21.7091 12C21.7091 6.65004 17.3491 2.29004 11.9991 2.29004ZM15.4991 14.5C15.7791 14.78 15.7791 15.23 15.4991 15.5C15.3591 15.64 15.1791 15.71 14.9991 15.71C14.8191 15.71 14.6391 15.64 14.4991 15.5L11.9991 13L9.49906 15.5C9.35906 15.64 9.17906 15.71 8.99906 15.71C8.81906 15.71 8.63906 15.64 8.49906 15.5C8.21906 15.22 8.21906 14.77 8.49906 14.5L10.9991 12L8.49906 9.50004C8.21906 9.22004 8.21906 8.77004 8.49906 8.50004C8.77906 8.23004 9.22906 8.22004 9.49906 8.50004L11.9991 11L14.4991 8.50004C14.7791 8.22004 15.2291 8.22004 15.4991 8.50004C15.7691 8.78004 15.7791 9.23004 15.4991 9.50004L12.9991 12L15.4991 14.5Z",
      fill: "currentColor"
    }
  ) }),
  "KmxClearFilled"
);
export {
  o as default
};
